"use client"

import { Box, TextField } from "@mui/material"
import { FileUploadField } from "./file-upload-field"

export function AddItemForm({ itemData, onItemChange, onFileChange, fields, fileId, fileLabel }) {
  return (
    <Box component="form" sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
      {fields.map((field) => (
        <TextField
          key={field.name}
          label={field.label}
          value={itemData[field.name] || ""}
          onChange={(e) => onItemChange((prev) => ({ ...prev, [field.name]: e.target.value }))}
          fullWidth
          required={field.required}
          placeholder={field.placeholder}
          multiline={field.multiline}
          rows={field.rows}
          autoFocus={field.autoFocus}
          size={field.size || "medium"}
        />
      ))}

      <FileUploadField id={fileId} file={itemData.file} onChange={onFileChange} label={fileLabel} />
    </Box>
  )
}
